import { useDispatch } from "react-redux"
import { EyeIcon, PencilIcon } from '@heroicons/react/24/solid'

import { EmptyValuePlaceholder } from "@/components/ui"
import { formatDate } from "@/utils/formatters"
import Contact from "../Contact"
import { setLocationInEdition } from '../../locations/locationsSlice'
import { setBien as setQuittancesBien, setLocation as setQuittancesLocation } from "../../quittances/quittancesSlice"
import { useBienContext } from "../BienContext"
import { useDetailContext } from '@/components/DetailTemplate'
import { FORM_TYPES } from '../../locations/LocationFormContext'

export default ({item, changeFormType = () => {}, setShowQuittances = () => {}}) => {
  const dispatch = useDispatch()
  const { bien } = useBienContext()
  const detailContext = useDetailContext()

  const handleEditClick = () => {
    dispatch(setLocationInEdition(item))
    if(item.date_fin_bail) {
      changeFormType(FORM_TYPES.CLOSE_EDIT)
    } else {
      changeFormType(FORM_TYPES.NEW)
    }
    detailContext.setModalVisible(true)
  }

  const handleExitClick = () => {
    dispatch(setLocationInEdition(item))
    changeFormType(FORM_TYPES.CLOSE)
    detailContext.setModalVisible(true)
  }

  const handleQuittancesClick = () => {
    if(item) {
      dispatch(setQuittancesBien(bien))
      dispatch(setQuittancesLocation(item))
      setShowQuittances(true)
      detailContext.setModalVisible(true)
    }
  }

  return (
    <tr data-object="location" data-id={item.id}
        className={`text-sm hover:bg-primary-200 transition-all duration-500`}
    >
      <td className="p-1">
        { item.locataires?.length > 0 && item.locataires.map((locataire, index) => (
          <Contact key={locataire.id} label="Locataire" item={locataire} index={index} />
        ))}
        { (!item.locataires || item.locataires?.length == 0 ) && (
          <EmptyValuePlaceholder />
        )}
      </td>

      <td>
        { item.date_effet_bail ? formatDate(item.date_effet_bail) : 
          <EmptyValuePlaceholder />
        }
      </td>
      <td>
        { item.date_etat_lieux_entree ? formatDate(item.date_etat_lieux_entree) :
          <EmptyValuePlaceholder />
        }
      </td>
      <td>
        { item.date_fin_bail ? formatDate(item.date_fin_bail) :
          <EmptyValuePlaceholder />
        }
      </td>
      <td>
        { item.date_etat_lieux_sortie ? formatDate(item.date_etat_lieux_sortie) :
          <EmptyValuePlaceholder />
        }
      </td>
      <td className="text-end px-2 space-x-2">
        {(item.date_effet_bail && !item.date_fin_bail) && (
          <button className='btn btn-primary'
            onClick={handleExitClick}
          >
            Départ Locataire
          </button>
        )}
        { item.date_fin_bail && 
          <button             
            className="quittances-btn btn btn-sm btn-ghost hover:bg-primary-400" 
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              handleQuittancesClick()
            }}
            title="Voir les quittances"
          >
            <EyeIcon className="h-5 w-5"/> Quittances
          </button>
        }
        <button className="btn btn-sm btn-ghost btn-square hover:bg-primary-400"
          onClick={handleEditClick}
        >
          <PencilIcon className="h-5 w-5"/>
        </button>
      </td>
    </tr>
  )
}